module.exports = __webpack_public_path__ + "media/images/pages/bg_area_06-ebbe705cd81e64a9d8d8c702449a9629.png";